function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/** @jsx createElement */

import { noop } from '@algolia/autocomplete-shared';
import { createTags } from './createTags';
export function createTagsPlugin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _getOptions = getOptions(options),
    initialTags = _getOptions.initialTags,
    getTagsSubscribers = _getOptions.getTagsSubscribers,
    transformSource = _getOptions.transformSource,
    onChange = _getOptions.onChange;
  var tags = createTags({
    initialTags: initialTags
  });
  var tagsApi = {
    setTags: tags.set,
    addTags: tags.add
  };
  return {
    name: 'aa.tagsPlugin',
    subscribe: function subscribe(params) {
      var setContext = params.setContext,
        onSelect = params.onSelect,
        setIsOpen = params.setIsOpen,
        refresh = params.refresh;
      var subscribers = getTagsSubscribers();
      setContext({
        tagsPlugin: _objectSpread(_objectSpread({}, tagsApi), {}, {
          tags: tags.get()
        })
      });
      onSelect(function (_ref) {
        var source = _ref.source,
          item = _ref.item;
        var subscriber = subscribers.find(function (_ref2) {
          var sourceId = _ref2.sourceId;
          return sourceId === source.sourceId;
        });
        if (subscriber) {
          tags.add([subscriber.getTag({
            item: item
          })]);
        }
      });
      tags.onChange(function (_ref3) {
        var prevTags = _ref3.prevTags;
        setContext({
          tagsPlugin: _objectSpread(_objectSpread({}, tagsApi), {}, {
            tags: tags.get()
          })
        });
        setIsOpen(true);
        onChange(_objectSpread(_objectSpread({}, params), {}, {
          prevTags: prevTags,
          tags: tags.get()
        }));
        refresh();
      });
    },
    getSources: function getSources(_ref4) {
      var state = _ref4.state;
      return [transformSource({
        source: {
          sourceId: 'tagsPlugin',
          getItems: function getItems() {
            return tags.get();
          },
          onSelect: function onSelect(_ref5) {
            var item = _ref5.item;
            item.remove();
          },
          templates: {
            item: function item(_ref6) {
              var item = _ref6.item,
                createElement = _ref6.createElement;
              return createElement("div", {
                className: "aa-TagsPlugin-Tag"
              }, createElement("span", {
                className: "aa-TagsPlugin-TagLabel"
              }, item.label), createElement("button", {
                type: "button",
                className: "aa-TagsPlugin-RemoveButton",
                title: "Remove this tag"
              }, createElement("svg", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                viewBox: "0 0 24 24"
              }, createElement("path", {
                d: "M18 6L6 18"
              }), createElement("path", {
                d: "M6 6L18 18"
              }))));
            }
          }
        },
        state: state
      })];
    },
    data: _objectSpread(_objectSpread({}, tagsApi), {}, {
      get tags() {
        return tags.get();
      }
    }),
    __autocomplete_pluginOptions: options
  };
}
function getOptions(options) {
  return _objectSpread({
    initialTags: [],
    getTagsSubscribers: function getTagsSubscribers() {
      return [];
    },
    transformSource: function transformSource(_ref7) {
      var source = _ref7.source;
      return source;
    },
    onChange: noop
  }, options);
}